import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export const PasswordInput = ({ className = "", ...props }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input {...props} type={show ? "text" : "password"} className={className} />
      <button type="button" onClick={() => setShow(!show)}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-white transition-colors"
        tabIndex={-1} data-testid={props["data-testid"] ? `${props["data-testid"]}-toggle` : "password-toggle"}>
        {show ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
};
